import { Inject, Injectable, Optional } from "@angular/core";
import { Platform } from '@angular/cdk/platform';
import { NativeDateAdapter } from '@matheo/datepicker/core';
import { MAT_DATE_LOCALE } from "@angular/material/core";

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  // we may need this for other locales - leaving here just in case
  // constructor(@Optional() @Inject(MAT_DATE_LOCALE) matDateLocale: string, platform: Platform) {
  //   super(matDateLocale, platform);
  // }

  parse(value: any): Date | null {
    try {
      const currentDate = new Date();
      let year: number = currentDate.getFullYear();
      let month: number = currentDate.getMonth();
      let day: number = currentDate.getDate();

      let hours: number = currentDate.getHours();
      let minutes: number = currentDate.getMinutes();
      let seconds: number = currentDate.getSeconds();

      if ((typeof value === 'string') &&
        ((value.indexOf('/') > -1) || (value.indexOf('.') > -1) || (value.indexOf('-') > -1) || (value.indexOf(':') > -1))) {
        const parts = value.split(/[ \t,]/).filter(x => x);
        const datePart = parts[0];
        const timePart = parts[1];
        const amOrPm = parts[2];

        // parse date part
        const str = datePart.split(/[\./-/:]/);

        day = !!str[0] ? +str[0] : day;
        month = !!str[1] ? +str[1] - 1 : month;
        year = !!str[2] ? +str[2] : year;

        // parse time part
        if (timePart) {
          const time = timePart.split(/[\./-/:]/);
          hours = !!time[0] ? +time[0] : hours;
          minutes = !!time[1] ? +time[1] : minutes;
          seconds = !!time[2] ? +time[2] : seconds;
        }

        // handle 12hr format
        if (amOrPm && amOrPm.toLowerCase() == "pm") {
          hours += 12;
        }

        return new Date(year, month, day, hours, minutes, seconds);
      }

      if (typeof value == 'number') {
        return new Date(value);
      }

      return value ? new Date(Date.parse(value)) : null;
    } catch (err) {
      return null;
    }
  }
}
